

























































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { ROUTE_NAMES } from "../router/routenames";
import { api as userApi } from "../store/modules/user";
@Component({})
export default class DoKoLobby extends Vue {
  createTourney(): void {
    this.$router.push({
      name: ROUTE_NAMES.START_GAME,
    });
  }
  navToRules(): void {
    this.$router.push({
      name: ROUTE_NAMES.RULES,
    });
  }
  navToStatistics(): void {
    this.$router.push({
      name: ROUTE_NAMES.STATISTICS,
    });
  }
  navToFriends(): void {
    this.$router.push({
      name: ROUTE_NAMES.PLAYERS,
    });
  }

  @Getter(userApi.getters.getAvatarId, { namespace: userApi.namespace })
  avatarId!: string;
}
